<template>
  <div
    class="spnod-admin__form--container container mx-0 w-100"
    :class="isMobile ? 'px-0' : 'px-3'">
    <b-form @submit.stop.prevent="handleSubmit">
      <b-form-input
        name="code"
        v-model="$v.form.code.$model"
        :state="validateState('code')"
        type="text"
        placeholder="Verification Code"
        size="sm"
        class="mb-2"
      ></b-form-input>
      <b-input-group class="mb-2">
        <b-form-input
          name="password"
          v-model="$v.form.password.$model"
          :state="validateState('password')"
          :type="isPasswordDisplayed"
          placeholder="Password"
          size="sm"
          class="mb-0"
        >
        </b-form-input>
        <b-input-group-append>
          <span class="input-group-text small spnod-cursor" @click="handlePassToggle">
            <i v-if="!showPassword" class="fa fa-eye fa-sm"></i>
            <i v-else class="fa fa-eye-slash fa-sm"></i>
          </span>
        </b-input-group-append>
      </b-input-group>
      <ul class="spnod-admin__form--list mb-2">
        <li>
          <router-link id="resend" class="spnod-admin__form--link" to="/resend-code">Resend Code</router-link>
        </li>
      </ul>
      <div v-if="form.error !== ''">{{ this.form.error }}</div>
      <b-form-group class="d-flex justify-content-end">
        <b-button class="spnod-admin__form--button" type="submit" size="sm" :disabled="isDisabled">
          <p v-if="!isSending">Send</p>
          <span v-else class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        </b-button>
      </b-form-group>
    </b-form>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'VerifyForm',
  mixin: [validationMixin],
  data() {
    return {
      form: {
        code: '',
        password: '',
        error: ''
      },
      showPassword: false,
      isSending: false
    }
  },
  computed: {
    ...mapGetters(['verified', 'signedUp', 'verifyError']),
    isDisabled() {
      const anyBlanks = Object.entries(this.form).some((arr) => {
        return arr[1] === '' && arr[0] !== 'error'
      })
      return anyBlanks || this.$v.form.$anyError
    },
    isPasswordDisplayed() {
      return this.showPassword ? 'text' : 'password'
    },
    isMobile() { return window.innerWidth <= 768 }
  },
  created () {
    let code = this.$route.query.code || ''
    if (code !== '') {
      this.validCode = !/^[aA-zZ0-9._%+-]+@[aA-zZ0-9.-]+\.[aA-zZ]{2,}$/.test(code)
      // if it's not an email address, it's probably our code so set it
      if (this.validCode === true) {
        this.form.code = code
      }
    }
  },
  methods: {
    ...mapActions(['doVerify']),
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name]
      return $dirty ? !$error : null
    },
    handleSubmit: async function (e) {
      this.$v.form.$touch()
      if (this.$v.form.$anyError) {
        return
      }
      this.isSending = true
      await this.doVerify(this.form)
      this.isSending = false
    },
    handlePassToggle() {
      this.showPassword = !this.showPassword
    }
  },
  validations: {
    form: {
      code: { required },
      password: { required },
      error: {}
    }
  },
  watch: {
    verified: function (newVal, oldVal) {
      if (newVal === true) {
        this.$router.push('/who-are-you')
      }
    },
    verifyError: function (newVal, oldVal) {
      if (newVal !== '') {
        this.form.error = newVal
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/app/components/Forms/VerifyForm.vue?c67f4e3e